<template>
  <div>
    <div class="d-flex gap-2">
      <v-text-field v-model="search" label="Pesquisar" outlined dense />
      <v-btn @click="reportChargebacks" color="primary"> Reportar </v-btn>
    </div>

    <v-alert v-if="error" type="error">
      {{ error }}
    </v-alert>

    <v-data-table
      :headers="headers"
      :items="chargebacks"
      :loading="loading"
    ></v-data-table>
    <ChargebackReportModal />
  </div>
</template>

<script>
import FINANCIAL from "@/services/admin/financial";
import ChargebackReportModal from "./ChargebackReportModal.vue";
export default {
  name: "ChargebackManagement",
  components: {
    ChargebackReportModal,
  },
  data: () => ({
    search: "",
    chargebacks: [],
    loading: false,
    error: null,
    headers: [
      { text: "ID", value: "id" },
      { text: "Dono", value: "Owner.name" },
      { text: "Evento", value: "Ticket[0].TicketBlock.TicketGroup.Party.name" },
      { text: "Valor", value: "amount" },
    ],
  }),
  methods: {
    async getChargebacks() {
      try {
        this.loading = true;
        this.error = null;
        const { chargebacks } = await FINANCIAL.getChargebacks();
        this.chargebacks = chargebacks;
      } catch (error) {
        this.error = error.message || "Erro ao buscar chargebacks";
      } finally {
        this.loading = false;
      }
    },
    reportChargebacks() {
      this.$emit("report-chargeback-modal");
    },
  },
  mounted() {
    this.getChargebacks();
  },
};
</script>
